import styles from "../../styles/layout/layout.module.css"
import {getIcon, getLogo} from "../../utils/helper";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export const linkLogoWhite = "assets/logo/logo kando2-trang.png"
export const linkLogoHami = "assets/logo/logo.png"
export const smoothScrollToId = (id, block = 'start', inline = 'nearest', navigate) => {

    console.log(`Attempting to scroll to element with ID: ${id}`);
    const element = document.getElementById(id);

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: block,
            inline: inline,
        });
        console.log(`Successfully found and scrolled to element:`, element);
    } else {
        try {
            console.log(`Element with ID "${id}" not found. Redirecting to home and attempting scroll.`);

            // Redirect về trang chủ
            navigate('/');

            // Sử dụng setTimeout để đảm bảo trang chủ đã render trước khi scroll
            setTimeout(() => {
                const elementAfterRedirect = document.getElementById(id);
                if (elementAfterRedirect) {
                    elementAfterRedirect.scrollIntoView({
                        behavior: 'smooth',
                        block: block,
                        inline: inline,
                    });
                    console.log(`Successfully found and scrolled to element after redirect:`, elementAfterRedirect);
                } else {
                    console.error(`Element with ID "${id}" still not found after redirect.`)
                }
            }, 500); // Chờ 500ms (có thể điều chỉnh nếu cần)
        } catch (error) {
            console.log(error, "error")
        }
    }
};
export const Header = () => {
    const headerRef = useRef(null);
    const containerHeaderRef = useRef(null);
    const navHeaderRef = useRef(null);
    const navMenuRef = useRef(null);
    const navMenuWrapRef = useRef(null);
    const overLoadRef = useRef(null);
    const navigate = useNavigate();  // Khởi tạo hook useNavigate
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');
    const [isScrolledTop, setIsScrolledTop] = useState(true); // Thêm state
    const [isScrollingDown, setIsScrollingDown] = useState(false); // Thêm state cho hướng cuộn
    const [isScrollingUp, setIsScrollingUp] = useState(false); // Thêm state cho hướng cuộn
    const [isActiveHeader, setIsActiveHeader] = useState(false); // Thêm state để theo dõi class "activeHeader"

    useEffect(() => {
        setActiveLink(location.pathname);
        gsap.to(navMenuWrapRef.current, {display: "none", duration: 0.5});
        gsap.to(navMenuRef.current, {x: '-100%', duration: 0.3, ease: 'power3.inOut'});
        gsap.to(overLoadRef.current, {opacity: 0, display: "none", duration: 0.3, ease: 'power3.inOut'});
    }, [location.pathname]);


    useEffect(() => {
        if (!containerHeaderRef.current || !navHeaderRef.current) return;

        if (isScrolledTop) {
            gsap.to(containerHeaderRef.current, {yPercent: 0, duration: 0.3, ease: 'power3.inOut'});
            gsap.to(navHeaderRef.current, {yPercent: 0, top: 35, duration: 0.3, ease: 'power3.inOut'});
            setIsActiveHeader(false); // Xóa class "activeHeader"
        } else {
            if (isScrollingUp) {
                gsap.to(navHeaderRef.current, {yPercent: 0, top: 0, duration: 0.3, ease: 'power3.inOut'});
                setIsActiveHeader(true); // Thêm class "activeHeader"
            } else {
                gsap.to(containerHeaderRef.current, {yPercent: -100, duration: 0.3, ease: 'power3.inOut'});
                gsap.to(navHeaderRef.current, {yPercent: -100, duration: 0.3, ease: 'power3.inOut'});
                setIsActiveHeader(false); // Xóa class "activeHeader"
                gsap.to(navHeaderRef.current, {yPercent: 0, top: 0, duration: 0.3, ease: 'power3.inOut'});
                setIsActiveHeader(true); // Thêm class "activeHeader"
            }
        }
    }, [isScrolledTop, isScrollingDown, isScrollingUp]);

    useEffect(() => {
        let lastScrollY = window.pageYOffset;

        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            const isTop = scrollTop === 0;
            const isDown = scrollTop > lastScrollY;
            const isUp = scrollTop < lastScrollY;

            // Cập nhật state nếu có thay đổi
            if (isTop !== isScrolledTop) {
                setIsScrolledTop(isTop);
            }
            if (isDown !== isScrollingDown) {
                setIsScrollingDown(isDown);
            }
            if (isUp !== isScrollingUp) {
                setIsScrollingUp(isUp);
            }

            lastScrollY = scrollTop; // Lưu vị trí cuộn hiện tại
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isScrolledTop, isScrollingDown, isScrollingUp]);
    const dataHeader = [
        [
            {
                icon: "address",
                text: "Mönchstraße 01, 09599 Freiberg",
                link: "https://maps.app.goo.gl/dczj2LdVkYREyRVk8"
            },
            {icon: "clock", text: " Mo geschlossen | Di-So: 11-15 & 17-22Uhr"},
        ],
        [
            {icon: "phone", text: "+4937312188290", link: 'tel:+4937312188290'},
            {icon: "mail", text: "info.hami.freiberg@gmail.com", link: "mailto:info.hami.freiberg@gmail.com"},
        ],
    ]
    const handleOpenScroll = () => {
        smoothScrollToId('tisch-reservieren', 'start', 'nearest', navigate)
    }
    const menus = [
        {
            label: "StartSeite",
            url: "/"
        },
        {
            label: "Speisekarte",
            url: "/speisekarte"
        },
        {
            label: "Über uns",
            url: "#",
            id: 'about-us',
            nonRedirect: true,
        }, {
            label: "Party Catering & Events",
            url: "#",
            id: 'party-event',
            nonRedirect: true,
        },
        // {
        //     label: "Online bestellen",
        //     url: "https://d-gastro24.de/order/hamirestaurant",
        //     target:"_blank"
        // },
        {
            label: "Tisch reservieren",
            url: "#",
            id: 'tisch-reservieren',
            nonRedirect: true,
        },
        // {
        //     label: "Impressum",
        //     url: "#"
        // }, {
        //     label: "Datenschutz",
        //     url: "#"
        // },
        {
            label: "Kontaktieren Sie uns",
            url: "/kontaktieren-sie-uns"
        },

    ]
    const closeMenuMobie = () => {
        if (navMenuWrapRef?.current) {
            gsap.to(navMenuWrapRef.current, {display: "none", duration: 0.5});
            gsap.to(navMenuRef.current, {x: '-100%', duration: 0.3, ease: 'power3.inOut'});
            gsap.to(overLoadRef.current, {opacity: 0, display: "none", duration: 0.3, ease: 'power3.inOut'});
        }
    }
    const openMenuMobie = () => {
        if (navMenuWrapRef?.current) {

            gsap.to(navMenuWrapRef.current, {display: "flex", duration: 0.3});
            gsap.to(navMenuRef.current, {scrollTop: 0, x: '0%', duration: 0.1, ease: 'power3.inOut'});
            gsap.to(overLoadRef.current, {opacity: 1, display: "block", duration: 0.3, ease: 'power3.inOut'});
        }
    }
    return (
        <div className={styles.container} ref={headerRef}>
            <div className={styles.containerHeader} ref={containerHeaderRef}>
                {dataHeader?.map((item, index) => {
                    return (
                        <div className={styles.itemHeaderContainer} key={index}>
                            {item.map((el, index2) => {
                                return (
                                    <>
                                        {el?.link ? (
                                            <Link className={styles.linkText} to={el?.link}>
                                                <div className={styles.itemHeader} key={index2}>
                                                    <div className={styles.icon}>
                                                        {getIcon(el.icon)}
                                                    </div>
                                                    {el.text}
                                                </div>
                                            </Link>
                                        ) : <div className={styles.itemHeader} key={index2}>
                                            <div className={styles.icon}>
                                                {getIcon(el.icon)}
                                            </div>
                                            {el.text}
                                        </div>}

                                        {index2 !== item.length - 1 ? <div className={styles.separator}>
                                            </div> :
                                            null}
                                    </>

                                );
                            })}
                        </div>
                    );
                })}
            </div>
            <div className={`${styles.header} ${isActiveHeader ? styles.activeHeader : ''}`} ref={navHeaderRef}>
                <div className={styles.container}>
                    <Link to={"/"} className={styles.logo}>
                        {getLogo()}
                    </Link>

                    <nav className={styles.navbar} data-navbar="">
                        <ul className={styles.navbarList}>
                            {menus?.map(({label, url, nonRedirect, id,target}, index) => {
                                return (
                                    <li className={styles.navbarItem} key={index}>
                                        <div onClick={() => {
                                            if(target) {
                                                window.open(url,target);
                                            }else if (nonRedirect) {

                                                smoothScrollToId(id, 'start', 'nearest', navigate)

                                            } else {
                                                navigate(url)
                                            }
                                        }}
                                             className={`${styles.navbarLink} ${styles.hoverUnderline} ${activeLink === url ? styles.active : ""}`}>
                                            <span className={styles.span}>{label}</span>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                    <div className={styles.wrapBtn}>

                        <button onClick={handleOpenScroll} type="button" className={`btnSecondary btn`}>
                            <span className={`text text1`}>Tisch reservieren</span>
                            <span className={`text text2`} aria-hidden="true">Tisch reservieren</span>
                        </button>

                        <div className={styles.navOpenBtn} onClick={openMenuMobie}>
                            <div className={`${styles.line} ${styles.line1}`}></div>
                            <div className={`${styles.line} ${styles.line2}`}></div>
                            <div className={`${styles.line} ${styles.line3}`}></div>
                        </div>
                    </div>


                </div>
            </div>
            <div className={styles.menuMobie} ref={navMenuWrapRef}>
                <div className={`${styles.containerOpenMobie} bg-black-10`} ref={navMenuRef}>
                    <nav className={`${styles.navbarMobie} ${styles.navbarMobieActive}`} data-navbar="">

                        <button className="close-btn" aria-label="close menu" data-nav-toggler="">
                            <ion-icon name="close-outline" aria-hidden="true" role="img"
                                      className="md hydrated"></ion-icon>
                        </button>

                        <Link to={"/"} className={styles.logoMobie}>
                            {getLogo(1)}
                        </Link>

                        <ul className={styles.navbarListMobie}>
                            {menus?.map(({label, url, nonRedirect, id,target}, index) => {
                                let isActive = activeLink === url;
                                return (
                                    <li className={styles.navbarItemMobie} key={index}>
                                        <div onClick={() => {
                                            if(target) {
                                                window.open(url,target);
                                            }else  if (nonRedirect) {
                                                smoothScrollToId(id, 'start', 'nearest', navigate)
                                            } else {
                                                navigate(url)
                                            }
                                        }}
                                             className={`${styles.navbarLink}  ${isActive ? styles.active : ""}`}>
                                            {isActive ? <div className={styles.separatorMobie}></div> : null} <span
                                            className={styles.span}>{label}</span>
                                        </div>
                                    </li>
                                )
                            })}


                        </ul>

                        <div className={`text-center ${styles.navbarTitle}`}>
                            <p className={`headline-2  `}>Besuchen Sie uns</p>

                            <div className={styles.infoMenu}>
                                <address className="body-4">
                                    Mönchstraße 01, 09599 Freiberg
                                </address>

                                <p className="body-4 navbar-text">Öffnungszeiten: Mo geschlossen | Di-So: 11-15 & 17-22Uhr</p>

                                <a href="mailto:info.hami.freiberg@gmail.com"
                                   className="body-4 sidebar-link">info.hami.freiberg@gmail.com</a>
                            </div>

                            <div className={styles.separator}></div>

                            <p className="contact-label">Buchungsanfrage</p>

                            <a href="tel:+4937312188290" className="body-1 contact-number hover-underline">
                                +4937312188290
                            </a>
                        </div>

                    </nav>
                </div>
                <div className={styles.overload} ref={overLoadRef} onClick={closeMenuMobie}>

                </div>
            </div>
        </div>
    )
}